import React from "react";
import { Text, View, StyleSheet, Image } from "react-native";
import { Tile } from '../../ui/components'
import arrowRight from '../../assets/images/chevron-right.png';
import moment from "moment-timezone";
import Theme from "../../theme";
import { defaultScale } from '../../utils/scaling';
import { BodyScanTypes } from 'fitbeat.models';

class StatsHistoryRow extends React.Component {
    constructor(props) {
        super(props);
        const { statsHistory, t } = props;
        const { testTime } = statsHistory;
        this.state = {
            formattedScanDate: moment(testTime).format("D MMM YYYY"),
            formattedScanTime: moment(testTime).format("HH:mm"),
        };
    }
    openStatsReport = () => {
        this.props.openStatsReport(this.props.statsHistory);
    };

    render() {
        const { statsHistory } = this.props;
        const { muscleMassMeterValue, weight, bodyFat, unit, type } = statsHistory;

        return (
            <Tile customStyle={styles.container}>
                <View style={styles.cell}>
                    <Text style={styles.date}>{this.state.formattedScanDate}</Text>
                    <Text style={styles.date}>{this.state.formattedScanTime}</Text>
                </View>
                <View style={styles.cell}>
                    <Text style={styles.metric}>{weight}{unit}</Text>
                </View>
                <View style={styles.cell}>
                    <Text style={styles.metric}>
                        {type === BodyScanTypes.Manual ? '-' : `${muscleMassMeterValue}${unit}`}
                    </Text>
                </View>
                <View style={styles.cell}>
                    <Text style={styles.metric}>
                        {type === BodyScanTypes.Manual ? '-' : `${Math.round(bodyFat * 10) / 10}%`}
                    </Text>
                </View>
            </Tile>
        );
    }

    shouldComponentUpdate() {
        return false;
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: Theme.WHITE,
        paddingVertical: defaultScale(5),
        marginHorizontal: defaultScale(10),
    },
    cell: {
        flex: 1,
        flexBasis: 0,
        paddingVertical: defaultScale(10),
        borderRightWidth: defaultScale(1),
        alignItems: "center",
        justifyContent: "center",
        borderRightColor: Theme.GREY_LIGHT
    },
    noBorder: {
        borderRightWidth: 0
    },
    date: {
        ...Theme.textStyle.small,
        color: Theme.GREY_DARK,
        fontFamily: Theme.CustomBold,
        textAlign: "center"
    },
    metric: {
        ...Theme.graphStyle.customMedium14,
        color: Theme.GREY_DARK,
        textAlign: "center",
        fontFamily: Theme.CustomBold,
    },
    arrowBox: {
        width: defaultScale(13),
        height: defaultScale(13),
    },
    rightArrowCell: {
        flex: 1,
        flexBasis: 0,
        alignItems: "flex-end",
        justifyContent: "center",
        paddingVertical: defaultScale(5),        
        marginHorizontal: defaultScale(10),
    },
});

export default StatsHistoryRow;
